module.exports = __webpack_public_path__ + "img/claritin_allergy_24_hour.ce402a39.png";